import { cn } from '@cocoonspace/ui/lib/utils'
import { format } from 'date-fns'
import { VideoIcon } from 'lucide-react'

import type {
	SchedulerCalendarEvent,
	SchedulerCalendarEventComponentProps,
} from './types'

const EventTypeIcon = ({ event }: { event: SchedulerCalendarEvent }) => {
	const icon = (event.metadata as { icon?: string } | null | undefined)?.icon

	switch (icon) {
		case 'camera':
			return <VideoIcon className='size-3!' />
		default:
			return null
	}
}

export const DefaultCalendarEvent = <T,>({
	event,
	selected,
	variant,
	view,
	onSelect,
}: SchedulerCalendarEventComponentProps<T>) => {
	return (
		<button
			type='button'
			className={cn(
				'bg-primary/10 text-foreground hover:bg-primary/15 flex h-full w-full flex-col rounded-md px-2 py-1 text-left text-[11px]',
				selected && 'ring-primary/40 ring-2',
			)}
			onClick={() => onSelect(event)}
		>
			<div
				className={cn(
					'flex items-center gap-1',
					view === 'week' && variant === 'timed' && 'font-medium',
				)}
			>
				<EventTypeIcon event={event} />
				<span className='truncate'>{event.title}</span>
			</div>

			{view === 'week' && variant === 'timed' && (
				<div className='text-muted-foreground/80 truncate'>
					{format(event.start, 'HH:mm')}–{format(event.end, 'HH:mm')}
				</div>
			)}
		</button>
	)
}
